export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-city/index.js